import RecoProductsList from 'components/ItemSubstitution/RecoProductsList/RecoProductsList';
import { withRecoProductsListProps } from 'viewModel/itemSubstitution/recoProductsList/withRecoProductsListProps';

export default withRecoProductsListProps(RecoProductsList);
